import { Action, createReducer, on } from '@ngrx/store';

import { BusinessCard } from '@planone/bau365/util-user-data';

import {
  enrichBusinessCardFailure,
  enrichBusinessCardSuccess,
  loadBusinessCardFailure,
  loadBusinessCardUnknown,
} from './business-card.actions';

export const BUSINESS_CARD_FEATURE_KEY = 'businessCard';

export interface BusinessCardState {
  businessCard: BusinessCard | undefined;
  loaded?: boolean;
  error?: unknown;
}

export interface BusinessCardPartialState {
  readonly [BUSINESS_CARD_FEATURE_KEY]: BusinessCardState;
}

export const initialState: BusinessCardState = {
  businessCard: undefined,
  loaded: false,
};

const businessCardReducer = createReducer(
  initialState,
  on(loadBusinessCardUnknown, (state) => ({ ...state, loaded: true })),
  on(enrichBusinessCardSuccess, (state, { businessCard }) => ({ ...state, businessCard, loaded: true })),
  on(loadBusinessCardFailure, enrichBusinessCardFailure, (state, { error }) => ({ ...state, error, loaded: true }))
);

export function reducer(state: BusinessCardState | undefined, action: Action) {
  return businessCardReducer(state, action);
}
